<ng-container
  *ngIf="{
    filter: filter$ | async,
    salaryOptions: salaryOptions$ | async,
    publishDateOptions: publishDateOptions$ | async,
    seniorityLevelOptions: seniorityLevelOptions$ | async,
    workScheduleOptions: workScheduleOptions$ | async,
    transportTypeOptions: transportTypeOptions$ | async,
    drivingLicenceOptions: drivingLicenceOptions$ | async,
    educationLevelOptions: educationLevelOptions$ | async,
    languageOptions: languageOptions$ | async,
    languageIds: languageIds$ | async,
    hardSkills: hardSkills$ | async,
    softSkills: softSkills$ | async,
    hardSkillSuggestions: hardSkillSuggestions$ | async,
    softSkillSuggestions: softSkillSuggestions$ | async,
    employmentFormOptions: employmentFormOptions$ | async,
    publishDefaultDateOption: publishDefaultDateOption$ | async,
    isFilterExpanded: isFilterExpanded$ | async,
    locationCount: locationCount$ | async,
    experienceCount: experienceCount$ | async,
    categoryTree: categoryTree$ | async,
    categoryIds: categoryIds$ | async,
    experienceFilter: experienceFilter$ | async,
    specializationCodes: specializationCodes$ | async,
    localityTree: localityTree$ | async,
    industryCodes: industryCodes$ | async,
    localityIds: localityIds$ | async
  } as data"
>
  <div
    (click)="onMobileFilterExpandToggle()"
    [ngClass]="{
      'expand-filter': !data.isFilterExpanded,
      'expand-filter--hidden': data.isFilterExpanded
    }"
  >
    <div class="expand-filter__text">
      {{ 'label.DetailedSearch' | translate }}
    </div>
    <div class="expand-filter__icon">
      <svg-icon src="../../../assets/img/common/expand-filter.svg"></svg-icon>
    </div>
  </div>
  <div
    class="ann-filter"
    [ngClass]="{ 'mobile-hidden': !data.isFilterExpanded }"
  >
    <div class="filter-container">
      <div
        class="actual-filters"
        [ngClass]="{
          'show-clear-filter': !data.isFilterExpanded,
          'show-clear-filter--hidden': data.isFilterExpanded
        }"
      >
        <div class="clear-search-filter">
          <div class="clear-search-filter__clear-filters">
            <span class="clear-search-filter__label">{{
              'label.SearchParameters' | translate
            }}</span>
            <span class="clear-search-filter__btn" (click)="onResetFilter()">{{
              'label.ClearFilter' | translate
            }}</span>
          </div>
        </div>

        <div class="ann-filters">
          <h6 class="header--bold">
            {{ 'label.AnnouncementType' | translate }}
          </h6>
          <div class="info-div-container">
            <div class="announcement-type">
              <app-ann-type-filter
                #announcementTypeDropdown
                [selectedTypeOption]="data.filter.announcementTypeId"
              ></app-ann-type-filter>
            </div>
            <div class="announcement-type-info-icon">
              <span matTooltip="{{ 'text.ExperienceType' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="ann-filters">
          <h6 class="header--bold">
            {{ 'label.SearchByKeyword' | translate }}
          </h6>
          <div class="info-div-container">
            <input
              type="text"
              class="search-query"
              [placeholder]="'label.SearchKeyword' | translate"
              (keyup.enter)="
                onSearch(
                  data.filter,
                  data.salaryOptions,
                  data.publishDateOptions
                )
              "
              (input)="onKeywordFilterChange(q.value)"
              [ngModel]="data.filter.query"
              #q
            />
            <div class="keyword-search-info-icon">
              <span matTooltip="{{ 'text.Keyword' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- locations -->
        <div class="ann-filters">
          <h6 class="header--bold locality-header">
            {{ 'label.WorkLocation' | translate }}
          </h6>
          <div class="info-div-container">
            <div class="localities">
              <hrra-location-tree-select
                #locationTreeSelect
                (updateTreeValue)="onToggleLocality($event)"
                [isLarge]="true"
                [PlaceholderText]="'label.Location'"
                [SelectItemCountText]="'label.SelectedCityCount'"
                [selectedNodes]="data.localityIds"
                [enableVirtualScroll]="true"
                [compressValues]="true"
              ></hrra-location-tree-select>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.WorkLocation' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
          <hrra-employment-form
            #employmentForm
            [filter]="data.filter"
            [employmentFormTypes]="data.filter.employmentFormTypeIds"
            (employment)="onEmploymentFormChange($event)"
          >
          </hrra-employment-form>
        </div>

        <!-- work experience -->
        <div class="ann-filters">
          <h6 class="header--bold work-experience-header">
            {{ 'label.WorkExperience' | translate }}
          </h6>
          <div class="info-div-container">
            <div class="specializations">
              <hrra-specialization-tree-select
                #specializationTreeSelect
                (updateTreeValue)="onToggleSpecialization($event)"
                [isLarge]="true"
                [PlaceholderText]="'label.SearchWithSpecialization'"
                [SelectItemCountText]="'label.SelectedSpecializationCount'"
                [selectedNodes]="data.specializationCodes"
                [enableVirtualScroll]="true"
                [compressValues]="true"
              ></hrra-specialization-tree-select>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.WorkSpecialization' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
          <div class="info-div-container">
            <div class="industries">
              <hrra-industry-tree-select
                #industryTreeSelect
                (updateTreeValue)="onToggleIndustry($event)"
                [isLarge]="true"
                [PlaceholderText]="'label.SearchWithIndustry'"
                [SelectItemCountText]="'label.SelectedIndustryCount'"
                [selectedNodes]="data.industryCodes"
                [enableVirtualScroll]="true"
                [compressValues]="true"
              ></hrra-industry-tree-select>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.WorkIndustry' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
          <div class="info-div-container">
            <div class="seniority-level">
              <p-multiSelect
                #seniorityLevelMultiSelect
                [options]="data.seniorityLevelOptions"
                (onChange)="onChangeSeniorityLevelOption($event)"
                optionLabel="name"
                [placeholder]="'label.SeniorityLevel' | translate"
                [optionValue]="'code'"
                [styleClass]="
                  (data.filter.seniorityLevelCodes &&
                  data.filter.seniorityLevelCodes.length > 0) ? 'dropdown-panel-selected': 'dropdown-panel'
                "
                [showToggleAll]="false"
                [panelStyleClass]="'dropdown-panel-style'"
                [showClear]="
                  data.filter.seniorityLevelCodes !== undefined &&
                  data.filter.seniorityLevelCodes !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.seniorityLevelCodes"
                (onClear)="onClearSeniorityLevel()"
                appCloseOnScroll="transportTypeRef"
              >
                <ng-template let-item #item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                   <div class="dropdwon-icon">
                    <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                   </div>
                </ng-template>

                <ng-template #clearicon>
                     <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                    <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.WorkSeniorityLevel' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>

          <hrra-work-experience
            [experienceFilter]="data.experienceFilter"
            (onExperienceFilter)="onToggleExperienceRangeOption($event)"
          ></hrra-work-experience>
        </div>

        <!-- work schedule -->
        <div class="ann-filters">
          <h6 class="header--bold work-schedule-header">{{ 'label.WorkSchedule' | translate }}</h6>
          <div class="info-div-container">
            <div class="work-schedule">
              <p-multiSelect
                #workScheduleMultiSelect
                [options]="data.workScheduleOptions"
                (onChange)="onChangeWorkScheduleOption($event)"
                optionLabel="name"
                [virtualScroll]="false"
                [optionValue]="'code'"
                [styleClass]="
                  (data.filter.workScheduleCodes &&
                  data.filter.workScheduleCodes.length > 0) ? 'dropdown-panel-selected' : 'dropdown-panel'
                "
                [panelStyleClass]="'dropdown-panel'"
                [placeholder]="'label.WorkSchedule' | translate"
                [showToggleAll]="false"
                [showClear]="
                  data.filter.workScheduleCodes !== undefined &&
                  data.filter.workScheduleCodes !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.workScheduleCodes"
                (onClear)="onClearWorkSchedule()"
              >

                <ng-template let-item #item>
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                  <div class="dropdwon-icon">
                    <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                  </div>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                    <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template let-item pTemplate="item">
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>
              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.WorkSchedule' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- salary range -->
        <div class="ann-filters">
          <hrra-salary
            #salaryDropdown
            [selectedSalaryOption]="data.filter.salaryRangeOptionId"
            [salaryOptions]="data.salaryOptions"
            [filter]="data.filter"
            (changeSalaryRangeOption)="onChangeSalaryRangeOption($event)"
            (onlySelectedSalary)="onOnlySelectedSalary($event)"
          >
          </hrra-salary>
        </div>

        <!-- education -->
        <div class="ann-filters">
          <h6 class="header--bold education-header">{{ 'label.Education' | translate }}</h6>
          <div class="info-div-container">
            <div class="education-level">
              <svg-icon
                class="new-field-badge"
                src="/assets/icons/new-field.svg"
              ></svg-icon>
              <p-multiSelect
                #educationLevelMultiSelect
                [options]="data.educationLevelOptions"
                (onChange)="onChangeEducationLevelOption($event)"
                optionLabel="name"
                [virtualScroll]="false"
                [optionValue]="'code'"
                [styleClass]="
                  (data.filter.educationLevelCodes &&
                  data.filter.educationLevelCodes.length > 0) ? 'dropdown-panel-selected' : 'dropdown-panel'
                "
                [panelStyleClass]="'dropdown-panel'"
                [placeholder]="'label.EducationLevel' | translate"
                [showToggleAll]="false"
                [showClear]="
                  data.filter.educationLevelCodes !== undefined &&
                  data.filter.educationLevelCodes !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.educationLevelCodes"
                (onClear)="onClearEducationLevels()"
              >

                <ng-template let-item #item>
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                  <div class="dropdwon-icon">
                    <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                  </div>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                    <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template let-item pTemplate="item">
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>
              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.EducationLevel' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- skills -->
        <div class="ann-filters skills-section">
          <h6 class="header--bold skills-header">{{ 'label.Skills' | translate }}</h6>

          <div class="info-div-container">
            <div class="skills">
              <svg-icon
                class="new-field-badge"
                src="/assets/icons/new-field.svg"
              ></svg-icon>
              <hrra-skills-filter
                [placeholder]="'label.HardSkills'"
                [allSkillsDialogTitle]="'label.SelectedHardSkills'"
                [skills]="data.hardSkills"
                [suggestions]="data.hardSkillSuggestions"
                (onQueryChange)="onSkillQueryChange($event, skillBaseType.Hard, data.hardSkills)"
                (onSkillsChange)="onSkillsChange($event, skillBaseType.Hard)"
              ></hrra-skills-filter>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.HardSkills' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>

          <div class="info-div-container">
            <div class="skills">
              <hrra-skills-filter
                [placeholder]="'label.SoftSkills'"
                [allSkillsDialogTitle]="'label.SelectedSoftSkills'"
                [skills]="data.softSkills"
                [suggestions]="data.softSkillSuggestions"
                (onQueryChange)="onSkillQueryChange($event, skillBaseType.Soft, data.softSkills)"
                (onSkillsChange)="onSkillsChange($event, skillBaseType.Soft)"
              ></hrra-skills-filter>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.SoftSkills' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- language -->

        <div class="ann-filters">
          <h6 class="header--bold language-header">{{ 'label.KnownLanguages' | translate }}</h6>
          <div class="info-div-container">
            <div class="language">
              <svg-icon
                class="new-field-badge"
                src="/assets/icons/new-field.svg"
              ></svg-icon>
              <p-multiSelect
                #languageMultiSelect
                [options]="data.languageOptions"
                (onChange)="onChangeLanguageOption($event)"
                optionLabel="name"
                [virtualScroll]="false"
                [optionValue]="'key'"
                [styleClass]="data.filter.worldLanguageIds && data.filter.worldLanguageIds.length > 0 ? 'dropdown-panel-selected' : 'dropdown-panel'"
                [panelStyleClass]="'dropdown-panel'"
                [placeholder]="'label.Language' | translate"
                [showToggleAll]="false"
                [showClear]="
                  data.filter.worldLanguageIds !== undefined &&
                  data.filter.worldLanguageIds !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.worldLanguageIds"
                (onClear)="onClearDrivingLicences()"
              >

                <ng-template let-item #item>
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template #clearicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                   <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template let-item pTemplate="item">
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>
              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.KnownLanguages' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- transport type -->
        <div class="ann-filters">
          <h6 class="header--bold transport-header">{{ 'label.DrivingLicenceType' | translate }}</h6>
          <div class="info-div-container">
            <div class="driving-licence">
              <svg-icon
                class="new-field-badge"
                src="/assets/icons/new-field.svg"
              ></svg-icon>
              <p-multiSelect
                #drivingLicenceMultiSelect
                [options]="data.drivingLicenceOptions"
                (onChange)="onChangeDrivingLicenceOption($event)"
                optionLabel="name"
                [virtualScroll]="false"
                [optionValue]="'value'"
                [styleClass]="data.filter.drivingLicenceIds && data.filter.drivingLicenceIds.length > 0 ? 'dropdown-panel-selected' : 'dropdown-panel'"
                [panelStyleClass]="'dropdown-panel'"
                [placeholder]="'label.DrivingLicenceCategory' | translate"
                [showToggleAll]="false"
                [showClear]="
                  data.filter.drivingLicenceIds !== undefined &&
                  data.filter.drivingLicenceIds !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.drivingLicenceIds"
                (onClear)="onClearDrivingLicences()"
              >

                <ng-template let-item #item>
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template #clearicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                   <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template let-item pTemplate="item">
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>
              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.DrivingLicenceCategory' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
          <div class="info-div-container">
            <div class="transport-type">
              <p-multiSelect
                #transportTypeMultiSelect
                [options]="data.transportTypeOptions"
                (onChange)="onChangeTransportTypeOption($event)"
                optionLabel="name"
                [virtualScroll]="false"
                [optionValue]="'code'"
                [styleClass]="data.filter.transportTypeIds && data.filter.transportTypeIds.length > 0 ? 'dropdown-panel-selected' : 'dropdown-panel'"
                [panelStyleClass]="'dropdown-panel'"
                [placeholder]="'label.TransportTypeRequirement' | translate"
                [showToggleAll]="false"
                [showClear]="
                  data.filter.transportTypeIds !== undefined &&
                  data.filter.transportTypeIds !== []
                "
                [appendTo]="'body'"
                [ngModel]="data.filter.transportTypeIds"
                (onClear)="onClearTransportTypes()"
              >

                <ng-template let-item #item>
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #dropdownicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/arrow-down.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template #clearicon>
                     <div class="dropdwon-icon">
                      <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'arrow-class'"></svg-icon>
                     </div>
                </ng-template>

                <ng-template pTemplate="selectedItems" let-selectedItems>
                  <ng-container *ngIf="selectedItems?.length < maxSelectedValue">
                   <span *ngFor="let item of selectedItems; let last = last">{{
                      last ? item.name : item.name + ', '
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="selectedItems?.length >= maxSelectedValue">
                    <span>
                      {{
                        'label.SelectedMultiselectOptions'
                          | translate: { count: selectedItems.length }
                      }}
                    </span>
                  </ng-container>
                </ng-template>
              </p-multiSelect>

              <ng-template let-item pTemplate="item">
                <span class="dropdown-item">{{ item.name }}</span>
              </ng-template>
              <ng-template pTemplate="dropdownicon">
                <svg-icon
                  src="/assets/icons/arrow-down.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </ng-template>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.TransportTypeRequirement' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <!-- published -->
        <div class="ann-filters ann-filters-last">
          <h6 class="header--bold publish-date-header">{{ 'label.Published' | translate }}</h6>
          <div class="info-div-container">
            <div class="publish-date">
              <p-select
                [ngModel]="data.filter.publishDateRangeOptionId"
                [options]="data.publishDateOptions"
                optionLabel="name"
                optionValue="key"
                [styleClass]="data.filter.publishDateRangeOptionId ? 'publishDateDropdown-selected' : 'publishDateDropdown'"
                [panelStyleClass]="'dropdown-panel'"
                [showClear]="
                  data.filter.publishDateRangeOptionId !==
                  data.publishDefaultDateOption?.key
                "
                (ngModelChange)="onChangePublishDateRangeOption($event)"
                [placeholder]="'label.Published' | translate"
                [appendTo]="'body'"
                (onClear)="onClearPublishDateRange()"
              >
                <ng-template pTemplate="item" let-item>
                  <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #clearicon>
                  <svg-icon src="/assets/icons/close-small.svg" [svgClass]="'dropdown-icon'"></svg-icon>
                </ng-template>

                <ng-template #selectedItem let-selectedOption>
                  <span *ngIf="selectedOption" [ngClass]="{'dropdown-value-grey' : data.filter.publishDateRangeOptionId === data.publishDefaultDateOption?.key, 'dropdown-value-green' : data.filter.publishDateRangeOptionId !== data.publishDefaultDateOption?.key}">{{ selectedOption?.name }}</span>
                </ng-template>

                <ng-template pTemplate="dropdownicon">
                  <svg-icon
                    src="/assets/icons/arrow-down.svg"
                    [svgStyle]="{
                      display: 'flex',
                      'justify-content': 'center',
                      'align-items': 'center'
                    }"
                  ></svg-icon>
                </ng-template>
              </p-select>
            </div>
            <div class="info-icon">
              <span matTooltip="{{ 'text.PublishDate' | translate }}">
                <svg-icon
                  src="/assets/icons/info-circle.svg"
                  [svgStyle]="{
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center'
                  }"
                ></svg-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="search-buttons">
          <button
            class="search-btn"
            (click)="
              onSearch(data.filter, data.salaryOptions, data.publishDateOptions)
            "
          >
            {{ 'label.Search' | translate }}
          </button>
          <div class="search-buttons__clear-filters">
            <span class="search-buttons__label">{{
              'label.SearchParameters' | translate
            }}</span>
            <span class="search-buttons__btn" (click)="onResetFilter()">{{
              'label.ClearFilter' | translate
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header>
        <mat-panel-title>
            Location
        </mat-panel-title>
        </mat-expansion-panel-header>
    
        <p>This is the primary content of the panel.</p>
    
    </mat-expansion-panel> -->
  </div>
</ng-container>
